/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Parts of value chain

Values: upstream=Upstream, own_operations=OwnOperations, downstream=Downstream
 * @export
 * @enum {string}
 */

export enum DoubleMaterialityValueChainPart {
    Upstream = 'upstream',
    OwnOperations = 'own_operations',
    Downstream = 'downstream'
}


